<template>
  <div class="div-conteudo">
    <CabecalhoPdf ref="cabecalhoPdf" />
    <div class="index centro">
      <div class="topo-index">
        <h1>Mandatos</h1>
      </div>
        <div class="caixa-pesquisa" v-if="ehAdministrador">
          <h2 @click="tooglePesquisa()">
            Pesquisa
            <span>
              <template v-if="!exibirPesquisa">&#9650;</template>
              <template v-else>&#9660;</template>
            </span>
          </h2>
          <transition name="slide">
            <form @submit.prevent="carregarColegiados" v-if="!exibirPesquisa">
              <div class="search-flex-container">
                <div class="item" v-if="ehAdministrador" style="min-width: 250px; flex: 1;">
                  <label for="selectedOrgao" style="font-weight: bold; margin-bottom: 5px; display: block;">Órgão:</label>
                  <v-select
                    class="vselect" 
                    v-model="selectedOrgao" 
                    id="selectedOrgao" 
                    :options="paginated"
                    label="nome" 
                    placeholder="Todos os Órgãos"
                    :filterable="false" 
                    @search="onSearch"
                  >
                    <li slot="list-footer" class="pagination" style="display: flex; justify-content: space-between; padding: 5px 10px;">
                      <button :disabled="!hasPrevPage" @click.prevent="offset -= limit" class="btn-pag-arrow">Anterior</button>
                      <button :disabled="!hasNextPage" @click.prevent="offset += limit" class="btn-pag-arrow">Próxima</button>
                    </li>
                  </v-select>
                </div>

                <div class="item">
                    <label>Remunerado:</label>
                    <div class="radio-container">
                      <label class="radio-label">
                        <input type="radio" v-model="filtro.remunerado" value="true" class="radio-input">
                        Sim
                      </label>
                      <label class="radio-label">
                        <input type="radio" v-model="filtro.remunerado" value="false" class="radio-input">
                        Não
                      </label>
                      <label class="radio-label">
                        <input type="radio" v-model="filtro.remunerado" :value="null" class="radio-input">
                        Todos
                      </label>
                    </div>
                  </div>
                <div class="botoes-pesquisa-container">
                  <div class="botoes-pesquisa">
                    <div class="bt-pesquisa">
                      <button title="Pesquisar" type="submit">
                        <img src="../../assets/imagens/pesquisa.png" class="pesquisa" alt=" " />
                        Pesquisar
                      </button>
                    </div>
                    <div class="bt-limpar">
                      <button title="Limpar" @click="limparFiltro()">
                        <img src="../../assets/imagens/icon-eraser.png" class="limpar" alt=" " />
                        Limpar Filtros
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </transition>
        </div>
      <div class="cessoes">

        <h2 @click="toggleSection('30Dias')" class="toggle-titulo">
          Mandatos com encerramento próximo (&lt; 30 dias)
          <span class="toggle-icone">{{ show30Dias ? '▼' : '▶' }}</span>
        </h2>
        <div ref="pdf30Dias" class="container-tabela" :class="{ 'tema-30': ehUsuarioExterno }" v-if="show30Dias">
          <TabelaResultadosHome :colegiados="colegiados30Dias" :dias="30" :ativar-zebrado="ehAdministrador" v-if="!carregando && !erro"></TabelaResultadosHome>
          <div class="action-buttons-container">
            <button @click.stop="exportToCsv(colegiados30Dias, 'mandatos_30_dias.csv')" class="export-button">Exportar CSV</button>
            <button @click.stop="gerarPdf('pdf30Dias', 'Mandatos com Encerramento Próximo (< 30 Dias)')" class="export-button pdf-btn">Exportar PDF</button>
          </div>

        </div>

        <h2 @click="toggleSection('60Dias')" class="toggle-titulo">
          Mandatos com encerramento próximo (&lt; 60 dias)
          <span class="toggle-icone">{{ show60Dias ? '▼' : '▶' }}</span>
        </h2>
        <div ref="pdf60Dias" class="container-tabela" :class="{ 'tema-60': ehUsuarioExterno }" v-if="show60Dias">
          <TabelaResultadosHome :colegiados="colegiados60Dias" :dias="60" :ativar-zebrado="ehAdministrador" v-if="!carregando && !erro"></TabelaResultadosHome>
          <div class="action-buttons-container">
            <button @click.stop="exportToCsv(colegiados60Dias, 'mandatos_60_dias.csv')" class="export-button">Exportar CSV</button>
            <button @click.stop="gerarPdf('pdf60Dias', 'Mandatos com Encerramento Próximo (< 60 Dias)')" class="export-button pdf-btn">Exportar PDF</button>
          </div>
        </div>

        <h2 @click="toggleSection('90Dias')" class="toggle-titulo">
          Mandatos com encerramento próximo (&lt; 90 dias)
          <span class="toggle-icone">{{ show90Dias ? '▼' : '▶' }}</span>
        </h2>
        <div ref="pdf90Dias" class="container-tabela" :class="{ 'tema-90': ehUsuarioExterno }" v-if="show90Dias">
          <TabelaResultadosHome :colegiados="colegiados90Dias" :dias="90" :ativar-zebrado="ehAdministrador" v-if="!carregando && !erro"></TabelaResultadosHome>
          <div class="action-buttons-container">
            <button @click.stop="exportToCsv(colegiados90Dias, 'mandatos_90_dias.csv')" class="export-button">Exportar CSV</button>
            <button @click.stop="gerarPdf('pdf90Dias', 'Mandatos com Encerramento Próximo (< 90 Dias)')" class="export-button pdf-btn">Exportar PDF</button>
          </div>
        </div>

        <h2 @click="toggleSection('120Dias')" class="toggle-titulo" v-if="ehAdministrador">
         Mandatos com encerramento próximo (&lt; 120 dias)
          <span class="toggle-icone">{{ show120Dias ? '▼' : '▶' }}</span>
        </h2>
        
        <div ref="pdf120Dias" class="container-tabela" v-if="show120Dias && ehAdministrador">
          <TabelaResultadosHome :colegiados="colegiados120Dias" :dias="120" :ativar-zebrado="ehAdministrador" v-if="!carregando && !erro"></TabelaResultadosHome>
          <div class="action-buttons-container">
            <button @click.stop="exportToCsv(colegiados120Dias, 'mandatos_120_dias.csv')" class="export-button">Exportar CSV</button>
            <button @click.stop="gerarPdf('pdf120Dias', 'Mandatos com Encerramento Próximo (< 120 Dias)')" class="export-button pdf-btn">Exportar PDF</button>
          </div>
        </div>
        
        <h2 @click="toggleSection('vencido')" class="toggle-titulo">
          Mandatos vencidos
          <span class="toggle-icone">{{ showVencido ? '▼' : '▶' }}</span>
        </h2>
        
        <div ref="pdfVencidos" class="container-tabela" :class="{ 'tema-vencido': ehUsuarioExterno }" v-if="showVencido">
          
          <TabelaResultadosHome 
              :colegiados="colegiadosVencido" 
              :dias="121" 
              :ativar-zebrado="!ehUsuarioExterno" 
              v-if="!carregando && !erro">
          </TabelaResultadosHome>

          <div class="action-buttons-container">
            <button @click.stop="exportToCsv(colegiadosVencido, 'mandatos_vencidos.csv')" class="export-button">Exportar CSV</button>
            <button @click.stop="gerarPdf('pdfVencidos', 'Mandatos Vencidos')" class="export-button pdf-btn">Exportar PDF</button>
          </div>
        </div>

        <h2 @click="toggleSection('exaurido')" class="toggle-titulo">
          Mandatos Exauridos de Recondução
          <span class="toggle-icone">{{ showExaurido ? '▼' : '▶' }}</span>
        </h2>

        <div ref="pdfExauridos" class="container-tabela" v-if="showExaurido">
          <TabelaResultadosHome :colegiados="colegiadosExaurido" :ativar-zebrado="ehAdministrador" v-if="!carregando && !erro"></TabelaResultadosHome>
          <div class="action-buttons-container">
            <button @click.stop="exportToCsv(colegiadosExaurido, 'mandatos_exauridos.csv')" class="export-button">Exportar CSV</button>
            <button @click.stop="exportToPdf('pdfExauridos', 'Mandatos Exauridos/Inelegíveis')" class="export-button pdf-btn">Exportar PDF</button>
          </div>
        </div>

        </div>
    </div>
  </div>
</template>
  
<script>
  import TabelaResultadosHome from "../../components/home/TabelaResultadosHome.vue";
  import HomeApi from "../../services/HomeApi";
  import metaDados from "../../helpers/metaDados";
  import Auth from "../../services/Auth";
  import ColegiadoApi from "../../services/ColegiadoApi";

  import html2pdf from 'html2pdf.js';
  import html2canvas from 'html2canvas';
  import vSelect from 'vue-select';
  import CabecalhoPdf from '../../components/pdf_components/Cabecalho.vue';
  
  export default {
    name: "Home",
    metaInfo() {
        return {
            title: "Home",
            titleTemplate: "%s - Casa Civil do Estado de Goiás",
            meta: [
                {
                    vmid: "og:title",
                    property: "og:title",
                    content: "Home - Casa Civil do Estado de Goiás",
                },
                ...metaDados(this.$route),
            ],
        };
    },
    computed: {
      // 1. Helper para pegar os dados do usuário (ID, Nome, Funcionalidades, etc)
      usuarioLogado() {
        const auth = new Auth();
        return auth.usuario;
      },
      ehAdministrador() {
        const usuario = this.usuarioLogado;
        if (usuario && usuario.funcionalidades) {
          return usuario.funcionalidades.includes('home_new_edit_delete');
        }
        
        return false;
      },
      ehUsuarioExterno() {
        return this.usuarioLogado && !this.ehAdministrador;
      },
      filteredOrgaos() {
      if (!this.search) return this.optionsOrgaos;
      return this.optionsOrgaos.filter(orgao => 
        orgao.nome.toLowerCase().includes(this.search.toLowerCase()));
      },

      paginated() {
        return this.filteredOrgaos.slice(this.offset, this.offset + this.limit);
      },

      hasPrevPage() {
        return this.offset > 0;
      },

      hasNextPage() {
        return this.offset + this.limit < this.filteredOrgaos.length;
      },
    },
    data() {
      return {
        colegiadosExaurido: [],
        colegiadosVencido: [],
        colegiados30Dias: [],
        colegiados60Dias: [],
        colegiados90Dias: [],
        colegiados120Dias: [],
        carregando: true,
        erro: false,
        filtro: {
          remunerado: 'true',
        },
        selectedOrgao: null,
        orgaos: [],
        optionsOrgaos: [],
        search: '',
        limit: 10, // Tamanho da página do dropdown
        offset: 0, // Deslocamento da paginação
        carregandoFiltro: false,
        erroFiltro: false,
        exibirPesquisa: true,
        showExaurido: true,
        showVencido: true,
        show30Dias: true,
        show60Dias: true,
        show90Dias: true,
        show120Dias: true,
      };
    },
    components: {
      TabelaResultadosHome,
      vSelect,
      CabecalhoPdf,
    },
    created() {
      this.colegiadoApi = new ColegiadoApi();
      this.carregarColegiados();

      if (this.ehAdministrador) {
        this.carregarValoresFiltro();
      }
    },
    methods: {
      toggleSection(sectionName) {
        if (sectionName === 'exaurido') {
          this.showExaurido = !this.showExaurido;
        } else if (sectionName === 'vencido') {
          this.showVencido = !this.showVencido;
        } else if (sectionName === '30Dias') {
          this.show30Dias = !this.show30Dias;
        } else if (sectionName === '60Dias') {
          this.show60Dias = !this.show60Dias;
        } else if (sectionName === '90Dias') {
          this.show90Dias = !this.show90Dias;
        } else if (sectionName === '120Dias') {
          this.show120Dias = !this.show120Dias;
        }
      },
      tooglePesquisa() {
        this.exibirPesquisa = !this.exibirPesquisa;
      },
      limparFiltro() {
        this.filtro.remunerado = null;
        this.selectedOrgao = null;
        this.search = '';
        this.offset = 0;
        this.carregarColegiados();
      },

      onSearch(query) {
        this.search = query
        this.offset = 0 // Reseta a página ao digitar para não quebrar a paginação
      },

      setarOptions() {
        this.optionsOrgaos = []; 
        for (let i = 0; i < this.orgaos.length; i++) {
          this.optionsOrgaos.push({
            id: this.orgaos[i].id,
            nome: this.orgaos[i].nome,
            sigla: this.orgaos[i].sigla
          });
        }
      },

      async carregarValoresFiltro() {
        try {
          this.erroFiltro = false;
          const response = await this.colegiadoApi.getOrgao();
          this.orgaos = response || [];
          this.orgaos.forEach((orgao) => {
            if (orgao.sigla !== undefined && orgao.sigla !== '') {
              orgao.nome = orgao.sigla + " - " + orgao.nome;
            }
          });
          this.setarOptions();
        } catch (err) {
          console.error("Erro ao carregar valores de filtro do órgão:", err);
          this.erroFiltro = true;
        }
      },
      async carregarColegiados() {
        try {
          this.carregando = true;
          this.erro = false;
  
                              const homeApi = new HomeApi();
  
                              
  
                              const params = {
  
                                qtd_por_pagina: 100000000000000,
  
                                page: 1,
  
                              };
  
                    
  
                              if (this.filtro.remunerado !== null) {
  
                                params.remunerado = this.filtro.remunerado;
  
                              }
  
                    
        if (this.ehAdministrador && this.selectedOrgao) {
          params.orgao_id = this.selectedOrgao.id;
        }

          const [dataColegiados, dataExauridos] = await Promise.all([
            homeApi.getColegiados(params),
            homeApi.getMandatosExauridos(params),
          ]);
          const resultados = this.filtrarColegiadosPorOrgao(dataColegiados.resultados);
          this.colegiadosExaurido = this.filtrarColegiadosExauridos(this.filtrarColegiadosPorOrgao(dataExauridos.resultados));
          this.colegiados30Dias = this.filtrarColegiadosPorDias(resultados, 30);
          this.colegiados60Dias = this.filtrarColegiadosPorDias(resultados, 60);
          this.colegiados90Dias = this.filtrarColegiadosPorDias(resultados, 90);
          this.colegiados120Dias = this.filtrarColegiadosPorDias(resultados, 120);
          this.colegiadosVencido = this.filtrarColegiadosVencidos(resultados);

          this.carregando = false;
        } catch (err) {
          console.error(err);
          this.carregando = false;
          this.erro = true;
        }
      },
      filtrarColegiadosPorOrgao(colegiados) {
        if (!this.ehAdministrador || !this.selectedOrgao) {
          return colegiados;
        }

        if (this.selectedOrgao.sigla) {
          return colegiados.filter(colegiado => colegiado.orgao_sigla === this.selectedOrgao.sigla);
        }

        return colegiados.filter(colegiado => colegiado.orgao_nome === this.selectedOrgao.nome);
      },
      filtrarColegiadosPorDias(colegiados, dias) {
        return colegiados.filter(colegiado => this.calcularDiasRestantes(colegiado) <= dias && this.calcularDiasRestantes(colegiado) > (dias - 30) && colegiado.status_codigo === 1) ;
      },
      filtrarColegiadosExauridos(colegiados) {
        return colegiados.filter(colegiado => {
          const naoPermiteReconducao = colegiado.permite_reconducao === false;
          const naUltimaReconducao = Number.isInteger(colegiado.quantidade_reconducao) && colegiado.reconducoes_realizadas === colegiado.quantidade_reconducao;
          return (naoPermiteReconducao || naUltimaReconducao) && colegiado.status_codigo === 1;
        });
      },
      filtrarColegiadosVencidos(colegiados) {
        return colegiados.filter(colegiado => {
        const diasRestantes = this.calcularDiasRestantes(colegiado);
        return diasRestantes < 0 && colegiado.status_codigo === 1;
        });
      },
      calcularDiasRestantes(elemento) {
        if (elemento.data_termino !== null) {
          const dataTerminoObj = new Date(elemento.data_termino);
          const dataAtual = new Date();
          const diferencaEmMilissegundos = dataTerminoObj - dataAtual;
          const diasRestantes = Math.ceil(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));
          return diasRestantes;
        }
      },
      exportToCsv(data, filename) {
        if (!data || data.length === 0) {
          alert('Não há dados para exportar.');
          return;
        }

        const headers = [
          'Órgão',
          'Nome do Colegiado',
          'Tipo do Colegiado',
          'Nome do Membro',
          'CPF do Membro',
          'Tipo do Membro',
          'Data Inicial do Mandato',
          'Data Final do Mandato',
          'Remunerado',
          'Status'
        ];

        const tipoColegiadoMap = {
          0: 'Conselho',
          1: 'Comitê',
          2: 'Fórum',
          3: 'Diretoria',
          4: 'Câmara',
          5: 'Colégio',
          6: 'Junta'
        };

        const statusMap = {
          1: 'Em Estruturacao',
          2: 'Ativo',
          3: 'Inativo' 
        };

        const csvRows = data.map(row => {
          const newRow = [
            row.orgao_nome,
            row.colegiado_nome,
            tipoColegiadoMap[row.colegiado_tipo] || row.colegiado_tipo,
            row.membro_nome,
            row.cpf, // O formato de CPF já é tratado na tabela, aqui exportamos o valor bruto ou já formatado se vier assim.
            row.tipo_membro === 'titular' ? 'Titular' : 'Suplente',
            row.data_inicio ? new Date(row.data_inicio).toLocaleDateString('pt-BR') : '',
            row.data_termino ? new Date(row.data_termino).toLocaleDateString('pt-BR') : '',
            row.remunerado ? 'Sim' : 'Não',
            statusMap[row.status_codigo] || 'Desconhecido' // Fallback para status não mapeados
          ];
          return newRow.join(';');
        });
        
        const csvContent = '\uFEFF' + [headers.join(';'), ...csvRows].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },

      async gerarPdf(refName, titleSection) {
        const container = this.$refs[refName]
        if (!container) {
          alert('Tabela de dados não encontrada para exportação.')
          return
        }

        const pdfHeader = document.createElement('div')
        pdfHeader.className = 'pdf-print-only-header'
        pdfHeader.innerHTML = `
          <div style="text-align: center; margin-top: 5px; margin-bottom: 25px; border-bottom: 2px solid #005516; padding-bottom: 12px; font-family: Arial, sans-serif;">
            <h2 style="color: #005516; margin: 8px 0 4px 0; font-size: 1.6rem; font-weight: 800; text-transform: uppercase;">${titleSection}</h2>
          </div>
        `

        const style = document.createElement('style')
        style.id = 'pdf-home-print-styles'
        style.textContent = `
          .action-buttons-container,
          .export-button {
            display: none !important;
          }

          .resultados h2 {
            display: none !important;
          }

          .resultados table th:last-child,
          .resultados table td:last-child {
            display: none !important;
          }

          .resultados table {
            width: 100% !important;
            border-collapse: collapse !important;
            table-layout: auto !important;
          }

          .resultados th, .resultados td {
            border: 1px solid #cbd5e0 !important;
            padding: 8px 10px !important;
            font-size: 9pt !important;
            text-align: center !important;
            vertical-align: middle !important;
          }

          .resultados th {
            background-color: #005516 !important;
            color: white !important;
            text-transform: uppercase !important;
          }

          .resultados table {
            page-break-inside: auto !important;
            break-inside: auto !important;
          }

          .resultados tr,
          .resultados td {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }

          .resultados tbody tr:nth-child(odd) {
            background-color: #ffffff !important;
          }

          .resultados tbody tr:nth-child(even) {
            background-color: #f2f7ff !important;
          }

          .resultados .linha-cinza {
            background-color: inherit !important;
          }
        `
        document.head.appendChild(style)

        const options = {
          margin: [35, 15, 15, 15],
          filename: `${refName.replace('pdf', 'mandatos')}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            logging: false,
            scrollY: 0,
            scrollX: 0
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
          pagebreak: {
            mode: ['css'],
            avoid: '.resultados tr'
          }
        }

        try {
          const headerTemplate = this.$refs.cabecalhoPdf?.$refs?.headerBannerTemplate
          if (!headerTemplate) {
            throw new Error('Cabeçalho do PDF não foi encontrado.')
          }

          const canvasHeader = await html2canvas(headerTemplate, {
            useCORS: true,
            scale: 2,
            backgroundColor: '#f4f5f7',
            logging: false
          })
          const headerImgData = canvasHeader.toDataURL('image/png')

          container.insertBefore(pdfHeader, container.firstChild)

          const pdfInstance = await html2pdf().set(options).from(container).toPdf().get('pdf')
          const totalPages = pdfInstance.internal.getNumberOfPages()

          for (let i = 1; i <= totalPages; i++) {
            pdfInstance.setPage(i)
            pdfInstance.addImage(headerImgData, 'PNG', 15, 10, 267, 20)
            pdfInstance.setFontSize(8.5)
            pdfInstance.setTextColor(113, 128, 150)
            pdfInstance.text('Sistema de Colegiados – SISCOL', 15, 201)
            pdfInstance.text(String(i), 148.5, 201, { align: 'center' })
            pdfInstance.text(new Date().toLocaleDateString('pt-BR'), 272, 201)
          }

          pdfInstance.save(`${refName.replace('pdf', 'mandatos')}.pdf`)
        } catch (erro) {
          console.error('Erro ao gerar PDF da Home:', erro)
          alert('Ocorreu um erro ao gerar o PDF da Home.')
        } finally {
          // 4. LIMPEZA SEGURA: Remove o título temporário do DOM para a tela do usuário não sofrer alteração visual
          if (container && container.contains(pdfHeader)) {
            container.removeChild(pdfHeader)
          }
          if (document.head.contains(style)) {
            document.head.removeChild(style)
          }
        }
      }
    }
  };
</script>
  

<style lang="scss" scoped>

  .container-tabela {
    &.tema-30 {
      ::v-deep table {
        tbody tr {
          background-color: #ffe6e6; /* Fundo vermelho claro */
          
          &:hover {
            background-color: #ffcccc; /* Fundo mais escuro ao passar o mouse */
          }
        }
      }
    }
  }
  .container-tabela {
    &.tema-60 {
      ::v-deep table {
        tbody tr {
          background-color: #fffde6; /* Fundo amarelo claro */
          
          &:hover {
            background-color: #fdfacd; /* Fundo mais escuro ao passar o mouse */
          }
        }
      }
    }
  }
  .container-tabela {
    &.tema-90 {
      ::v-deep table {
        tbody tr {
          background-color: #eaffe6; /* Fundo verde claro */
          
          &:hover {
            background-color: #d3fdca; /* Fundo mais escuro ao passar o mouse */
          }
        }
      }
    }
  }



  .toggle-titulo {
    cursor: pointer;
    user-select: none;
    display: flex;
    justify-content: center; /* Centraliza o conteúdo horizontalmente */
    align-items: center;
  }
  .toggle-icone {
    font-size: 1.5em;
    margin-left: 10px;
  }
  .export-button {
    background-color: transparent;
    color: green;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    font-size: 0.8em;
    cursor: pointer;
    display: block;
    margin: 10px 10px 0 auto;
  }
  .export-button:hover {
    text-decoration: underline;
    color: red;
  }
  .botoes-pesquisa-container {
    display: inline;
    justify-content: flex-start;
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .radio-container {
    display: flex;
    gap: 1rem;
  }
  .radio-label {
    display: flex;
    align-items: center;
    gap: .5rem;
  }
  .search-flex-container {
    display: block;
    gap: 1rem;
  }
  .search-flex-container .item {
    width: auto;
  }
  .botoes-pesquisa {
    display: flex;
    justify-content: flex-start;
    gap: 1rem;
  }
  .radio-input {
    margin: 0;
  }

  @media screen and (min-width: "1066px") {
      .div-conteudo {
          width: 100vw;
          margin-bottom: 5rem;
          .centro {
              max-width: 96vw;
              margin: 0 auto;
          }
          .index {
              h2 {
                  font-family: "Montserrat-Medium";
                  font-weight: bold;
                  color: #005516;
                  font-size: 1.3rem;
                  text-align: center;
              }
              .topo-index {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 1.5rem;
                  margin-top: 1.5rem;

                  h1 {
                      font-family: "Montserrat-Medium";
                      font-weight: bold; 
                      color: #ffa600 !important;
                      font-size: 1.8rem;
                  }
              }
              .grid {
                  display: grid;
                  grid-template: "a b";
                  gap: 1rem;
              }
              .cessoes {
                  width: 100%;
                  margin: 0rem auto;
                  .container-tabela {
                      margin: 1rem auto;
                      border-radius: 1.5rem;
                      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
                      display: flex;
                      flex-direction: column;
                      align-items: flex-end;
                      overflow-x: auto; /* Add this */
                  }

              }
              /*.disposicoes {
                  width: fit-content;
                  .container-tabela {
                      margin: 1rem auto;
                      border-radius: 1.5rem;
                      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
                      width: 46vw;
                  }
              }*/
          }
      }
  }
  @media screen and (min-width: "60px") and (max-width: "1065px") {
      .div-conteudo {
          width: 100vw;

          .centro {
              width: 90vw;
              margin: 0 auto;
          }

          .index {
              .cessoes {
                  width: 100%;
                  margin: 0rem auto;
              }
              .disposicoes {
                  width: fit-content;
                  margin: 2rem 0 1rem 0;
              }
              h2 {
                  font-family: "Montserrat-Medium";
                  font-weight: bold;
                  color: #005516;
                  font-size: 1.3rem;
                  text-align: center;
              }
              .topo-index {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 1.5rem;
                  margin-top: 1.5rem;

                  h1 {
                      font-family: "Montserrat-Bold";
                      color: #ffa600 !important;
                      font-size: 1.8rem;
                  }

                  a {
                      color: #005516;
                      text-decoration: none;
                      font-family: "Montserrat-Medium";
                      border: #005516 solid 0.15rem;
                      padding: 0.3rem 2rem;
                      border-radius: 0.2rem;
                      transition: 0.2s;
                      margin-bottom: 1.5rem;
                      margin-top: 1.5rem;

                      span {
                          font-family: "Montserrat-Bolder";
                      }
                  }

                  a:hover {
                      color: white;
                      background-color: #005516;
                  }
              }

              .n-div {
                  display: flex;
                  justify-content: space-between;

                  .nresultados {
                      margin: 0.5rem 0.5rem 0.5rem 0.5rem;

                      label {
                          color: #005516;
                          font-size: 0.8rem;
                          font-family: "Montserrat-Bold";
                          margin-top: 0.5rem;
                      }
                  }

                  .npagina {
                      margin: 0.5rem 0.5rem 0.5rem 0.5rem;
                      text-align: end;

                      label {
                          color: #005516;
                          font-size: 0.8rem;
                          font-family: "Montserrat-Medium";
                          margin: 0.5rem .5rem 0 0;
                      }

                      select {
                          border: none;
                          background-color: #edf2ee;
                          font-size: 0.9rem;
                          margin-top: 0.5rem;
                          cursor: pointer;
                      }
                  }
              }

              .container-tabela {
                  margin-top: .5rem;
                  border-radius: 1.5rem;
                  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

                  .resultados {
                      width: 100%;
                      height: max-content;
                      margin: 0;
                  }
              }
          }
      }
  }
  .modal-mask {
      position: fixed;
      z-index: 1000;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      display: table;
      transition: opacity 0.3s ease;
  }
  .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
  }
  .modal-container {
      width: fit-content;
      height: 0px auto;
      margin: 0px auto;
      position: relative;
      overflow-y: auto;
      overflow-x: auto;
      font-size: 1.5rem;
      font-family: "Montserrat-Medium";

      img {
          width: 2rem;
          height: 2rem;
          margin-right: 1.6rem;
      }

      label {
          font-size: 1.3rem;
          color: rgba(255, 255, 255, 0.556);
          display: inline;
          position: relative;
          top: 0rem;
      }
  }
  .caixa-pesquisa {
        background-color: #ededed;
        padding: 1rem;
        border-radius: 1rem 1rem 0 0;
        .flex {
          display: inline-flex;
          gap: 1rem;
          margin: 1rem 0 0 0;
        }
        .row4 {
          display: grid;
          grid-template-columns: .25fr .25fr .25fr .25fr;
          gap: 1rem;

          .item {
            width: -webkit-fill-available;

            .mx-datepicker {
              border: none;
            }
          }
          
        }

        .row2 {
          display: grid;
          grid-template-columns: .5fr .5fr;
          gap: 1rem;

          .item {
            width: -webkit-fill-available;

            .mx-datepicker {
              border: none;
            }
          }
        }

        .row2-data {
          display: grid;
          grid-template-columns: repeat(4, 1fr); 
          gap: 1.5rem;

          .item {
            width: -webkit-fill-available;

            .mx-datepicker {
              border: none;
            }
          }
        }

        input {
          border-radius: 0.5rem;
          border: solid 0.1rem;
        }

        h2 {
          margin: 0;
          text-transform: uppercase;
          color: #005516;
          font-size: 1.2rem;
          font-family: "Montserrat-Bold";
          cursor: pointer;
        }

        .item {
          display: grid;
          margin: .5rem 0 .5rem 0;

          label {
            width: fit-content;
            margin-bottom: 0.3rem;
            color: black;
            font-family: "Karla", sans-serif;
            font-size: 0.95rem;
            font-weight: 500;
          }

          input {
            height: 2rem;
            font-family: "Montserrat-Medium";
            padding-left: 0.5rem;
            font-size: 0.9rem;
          }

          select {
            height: 2rem;
            border-radius: 0.5rem;
            border: solid 0.1rem;
            background-color: white;
            font-family: "Montserrat-Medium";
            font-size: 0.84rem;
          }
        }

        .botoes-pesquisa {
          display: flex;
          justify-content: space-between;
          margin-top: 1rem;

          .bt-pesquisa {
            text-align: center;

            button {
              height: 2.5rem;
              background-color: #005516;
              color: white;
              border: #005516 solid 0.15rem;
              font-size: 1rem;
              padding: 0.3rem 2rem;
              border-radius: 2rem;

              img {
                height: 1rem;
                margin-right: 0.5rem;
              }
            }

            button:hover {
              text-decoration: underline;
            }
          }

          .bt-limpar {
            text-align: center;

            button {
              height: 2.5rem;
              background-color: #FFFFFF;
              color: #000;
              border: white solid 0.15rem;
              font-size: 1rem;
              padding: 0.3rem 2rem;
              border-radius: 2rem;

              img {
                height: 1.5rem;
                margin-right: 0.5rem;
              }
            }

            button:hover {
              text-decoration: underline;
            }
          }
        }
      }
  /* Agrupa e alinha os botões de ação na direita */
  .action-buttons-container {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 15px;
  }

  .export-button.pdf-btn {
    background-color: #005516 !important;
    color: #ffffff !important;
  }

  .export-button.pdf-btn:hover {
    background-color: #004010 !important;
  }
  .vselect {
  background-color: #fff;
  border-radius: 0.5rem; 

  ::v-deep .vs__dropdown-toggle {    
    padding: 0 0 2px 0; 
    min-height: 2rem;
    height: 2rem;    
    border: solid 0.1rem #414040; 
    border-radius: 0.5rem;
    transition: border-color 0.15s ease-in-out;

    &:hover, &:focus-within {
      border-color: #005516;
    }
  }
  
  ::v-deep .vs__search {
    margin: 0;
    padding: 0 7px;
    height: 1.8rem;
    font-family: "Montserrat-Medium";
    font-size: 0.9rem;
  }
  
  ::v-deep .vs__selected {
    margin: 0;
    padding: 0 7px;
    line-height: 1.8rem;
    font-family: "Montserrat-Medium";
    font-size: 0.9rem;
  }
  
  ::v-deep .vs__actions {
    padding: 0 6px 0 3px;
  }
}

</style>